import type { IconData } from '@stacksjs/iconify-core'

export const mq1x1: IconData = {
  "body": "<path fill=\"#231f1e\" d=\"M0 0h512v512H0z\"/><path fill=\"#00a650\" d=\"M0 0h512v256H0z\"/><path fill=\"#ef1923\" d=\"M256 256L0 512V0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mq1x1
